import React, { JSX } from 'react'

const InfoIcon: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="8" cy="8" r="8" fill="black" />

    <g fill="white">
      <circle cx="8" cy="5" r="1.1" />
      <rect x="6.8" y="7.5" width="2.4" height="5.5" rx="1.1" />
    </g>
  </svg>
)

export default InfoIcon
